import { frontendURL } from '../../../helper/URLHelper';

const SupportWrapper = () => import('./SupportWrapper.vue');
const AccountDiagnostics = () => import('./AccountDiagnostics.vue');
const EventLogSearch = () => import('./EventLogSearch.vue');
const WebhookDeliveries = () => import('./WebhookDeliveries.vue');
const CampaignErrors = () => import('./CampaignErrors.vue');
const IncidentManagement = () => import('./IncidentManagement.vue');
const WhatsappFlowMetrics = () => import('./WhatsappFlowMetrics.vue');
const ConversationFlowTimeline = () => import('./ConversationFlowTimeline.vue');
const SupportLlmSettings = () => import('./SupportLlmSettings.vue');
const SupportAssistant = () => import('./SupportAssistant.vue');
const KnowledgeBase = () => import('./KnowledgeBase.vue');

const SUPPORT_ROLES = ['administrator', 'supervisor', 'master'];
const ADMIN_ROLES = ['administrator', 'master'];
const MASTER_ROLES = ['master'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/support'),
    component: SupportWrapper,
    children: [
      {
        path: '',
        redirect: 'diagnostics',
      },
      {
        path: 'diagnostics',
        name: 'support_diagnostics',
        roles: SUPPORT_ROLES,
        component: AccountDiagnostics,
      },
      {
        path: 'events',
        name: 'support_events',
        roles: SUPPORT_ROLES,
        component: EventLogSearch,
      },
      {
        path: 'webhook-deliveries',
        name: 'support_webhook_deliveries',
        roles: SUPPORT_ROLES,
        component: WebhookDeliveries,
      },
      {
        path: 'campaign-errors',
        name: 'support_campaign_errors',
        roles: SUPPORT_ROLES,
        component: CampaignErrors,
      },
      {
        path: 'incidents',
        name: 'support_incidents',
        roles: ADMIN_ROLES,
        component: IncidentManagement,
      },
      {
        path: 'whatsapp-flow',
        name: 'support_whatsapp_flow',
        roles: MASTER_ROLES,
        component: WhatsappFlowMetrics,
      },
      {
        path: 'conversation-timeline',
        name: 'support_conversation_timeline',
        roles: MASTER_ROLES,
        component: ConversationFlowTimeline,
      },
      {
        path: 'ai-settings',
        name: 'support_llm_settings',
        roles: MASTER_ROLES,
        component: SupportLlmSettings,
      },
      {
        path: 'assistant',
        name: 'support_knowledge_assistant',
        roles: MASTER_ROLES,
        component: SupportAssistant,
      },
      {
        path: 'knowledge-base',
        name: 'support_knowledge_base',
        roles: MASTER_ROLES,
        component: KnowledgeBase,
      },
    ],
  },
];
